import {GetGuidedWorkFlowValidationCount, getValidationCountForIds} from '../../components/Common/CanvasForm/Common/ValidationUtility';
import {documentTypes, validationFilter} from '../../util/uiconstants';

const getValidationsSlice = (state) => state.validations;
const getWithoutApprovalValidationsSlice = (state) => state.withoutapprovalvalidations;
export const getAuditPlanSummaryValidationsSlice = (state) => state.auditPlanSummaryValidations;

export const getValidationsForDocumentId = (state, documentId, isForDocumentsWithoutApprovals) => {
	let formValidations = [];

	if (documentId) {
		formValidations = isForDocumentsWithoutApprovals ? getWithoutApprovalValidationsSlice(state)[documentId] : getValidationsSlice(state)[documentId];
	}

	return formValidations;
};

export const getValidationsForDocumentIdList = (
	state,
	documentIds,
	filter = validationFilter.NONE,
	includeGuidedWorkflowValidationDetails = false,
	documentTypeId = documentTypes.guidedWorkflow
) => {
	let formValidations;
	const validationsSlice = getValidationsSlice(state);

	let incompleteResponseCount = 0,
		unresolvedCommentsCount = 0,
		guidedWorkflowValidationCount = 0,
		guidedWorkflowValidationDetails = [];

	if (Array.isArray(documentIds)) {
		formValidations = {};
		for (const docId of documentIds) {
			const documentValidations = validationsSlice[docId];

			if (documentValidations) {
				const validationCounts = getValidationCountForIds(undefined, undefined, undefined, documentValidations, filter, documentTypeId, true);

				incompleteResponseCount += validationCounts.incompleteCount;
				unresolvedCommentsCount += validationCounts.unresolvedCount;
				guidedWorkflowValidationCount += GetGuidedWorkFlowValidationCount(validationCounts.guidedWorkFlowValidations);
				if (includeGuidedWorkflowValidationDetails) {
					guidedWorkflowValidationDetails = [...guidedWorkflowValidationDetails, ...validationCounts.guidedWorkFlowValidations];
				}
			}
		}
	}

	return {
		incompleteCount: incompleteResponseCount,
		unresolvedCount: unresolvedCommentsCount,
		guidedWorkflowValidationCount,
		guidedWorkflowValidations: guidedWorkflowValidationDetails
	};
};
